import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../../home/button-classic/button-classic";
import { connect } from "react-redux";
import ACTIONS from "../../../../common/action_constant";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import AddRawMaterialMaster from "./add-raw-material-master";
import { getItemFromSessionStorage } from "Utils/sessionStorage";
import { getEmail, getUserId } from "Utils/common";

class RawMaterialMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      rawMaterialData: [],
      count: 10,
      productListData:[]
    };
  }
  componentDidMount() {
    this.getRawMaterialMasterData();
    this.getInventoryItem();
    this.getRouteCode()
  }

  getRawMaterialMasterData() {
    const { dispatch, companyId } = this.props;
    const { search, offset, limit } = this.state;
    let param = `?companyId=${companyId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_RAW_MATERIAL_LIST_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ rawMaterialData: res && res.list });
      },
    });
  }

  changeHandler = (value) => {
    this.setState({ search: value });
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, editData: "" });
  };

  onSaveRawMaterialMasterData = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_RAW_MATERIAL_MASTER,
      data,

      onSuccess: () => {
        this.setState({ isOpen: false }, this.getRawMaterialMasterData());
      },
    });
  };

   getRouteCode() {
    const { dispatch, companyId } = this.props;
    const { search, offset} = this.state;
    const param = {
      offset,
      limit: 10,
      companyId: companyId,
    };
    if (search) {
      param.search = search;
    }
    
    
    dispatch({
      type: ACTIONS.HOME.GET_ROUTE_CODE,
      param,
    });
  }

  onSearch = () => {
    this.setState({ offset: 0 }, this.getRawMaterialMasterData);
  };

  onUpdateRawMaterialMasterData = (data) => {
    const previousData = getItemFromSessionStorage("previousrawMaterialName");
    previousData["update_flag"] = true;
    previousData["user_email"] = getEmail();
    previousData["user_id"] = getUserId();
    const { dispatch } = this.props;
    const payload = {
      ...data,
      previous_data: previousData,
    };
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_RAW_MATERIAL_MASTER,
      data: payload,
      onSuccess: () => {
        this.setState(
          { isOpen: false, editData: "" },
          this.getRawMaterialMasterData
        );
      },
    });
  };

  editRawMaterialMaster = (data) => {
    this.setState({
      editData: data,
      isOpen: true,
    });
  };

  deleteRawMaterialMaster = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_RAW_MATERIAL_MASTER,
      data: data,
      onSuccess: () => {
        this.getRawMaterialMasterData();
      },
    });
  };


   getInventoryItem = (search) => {
		const company_id = this.props.companyId;
		let param = `${company_id}&count=${this.state.count}&offset=${this.state.offset}`;
		if(search) {
			param += `&search=${search}`;
		}
		const { dispatch } = this.props;
		dispatch({ type : ACTIONS.MASTER.INVENTORY_ITEM.GET_INVENTORY_ITEM, param, company_id ,
      
    onSuccess: (data) => {
				this.setState({ productListData: data.list && data.list.productMasters})
		}}
    );
	}

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getRawMaterialMasterData
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getRawMaterialMasterData
    );
  };

  clearFilterOnCancel = () => {
    this.setState({ search: "", offset: 0 }, this.getRawMaterialMasterData);
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId } = this.props;
    const masterType = 28;
    const navUrl = `/auditScreen/${companyId}/${masterType}`;
    history.push(navUrl);
  };

  getZones = () => {
    const { dispatch } = this.props;
    dispatch({ type: ACTIONS.PLANTS.GET_ZONES });
  };

  getCountry = () => {
    const { dispatch } = this.props;
    dispatch({ type: ACTIONS.MASTER.LOCATION_NETWORK.GET_COUNTRY });
  };

  render() {
    const { rawMaterialData } = this.state;
    const { zones, countryListData ,productList,routeCodeList} = this.props;
    return (
      <div className={"location-network"}>
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button value={"+ Add Raw Material"} click={this.toggleAdd} />
            <button
              className="button-classic"
              onClick={this.handleOnClickForAuditBtn}
            >
              Audit
            </button>
          </div>
        </div>
        <table className={"chain-details-section"}>
          <tr className={"list-section header"}>
            <td className={"tabel-header vol-th"}>Material Name </td>
            <td className={"tabel-header vol-th"}>Material Type </td>
            <td className={"tabel-header vol-th"}>Route </td>
            <td className={"tabel-header vol-th"}>Route Code</td>
            <td className={"tabel-header vol-th"}>Vehicle Type</td>
            <td className={"tabel-header vol-th"}>Actions</td>
          </tr>

          {(rawMaterialData || []).map((raw, sIndex) => {
            return (
              <div className={"list-section content"} key={`route_${sIndex}`}>
                <div
                  className={"tabel-header vol-td"}
                  style={{ textWrap: "wrap" }}
                >
                  {raw.product} - {raw.product_name}
                </div>
                <div className={"tabel-header vol-td"}>{raw.material_type}</div>
                <div className={"tabel-header vol-td"}>{raw.route}</div>
                <div className={"tabel-header vol-td"}>{raw.route_code}</div>
                <div className={"tabel-header vol-td"}>{raw.vehicle_type}</div>
                <div className={"tabel-header vol-act"}>
                  <div
                    className={"action-icon"}
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editRawMaterialMaster(raw)}
                  />
                  <div
                    className={"action-icon"}
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deleteRawMaterialMaster(raw)}
                  />
                </div>
              </div>
            );
          })}
        </table>
        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>
        {this.state.isOpen && (
          <AddRawMaterialMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSaveRawMaterialMasterData}
            companyId={this.props.companyId}
            editData={this.state.editData}
            onUpdate={this.onUpdateRawMaterialMasterData}
            zones={zones}
            countryListData={countryListData}
            productList={this.state.productListData}
            routeCodeList={routeCodeList}
            getInventoryItem={this.getInventoryItem}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zones: state.plantsDepots.zones,
    countryListData: state.master.countryList,
    productList: state.master.itemList,
    routeCodeList: state.home.routeCodes || [],
  };
};

export default connect(mapStateToProps)(withRouter(RawMaterialMaster));
